import React from "react";
import { Card, Box, Typography } from "@mui/material";

const Card38WebCard = ({ card }) => {
    const cardData = card.cardData[0]?.data || {}; // Safely access card data

    // Extract query parameters from the current URL
    const currentQueryParams = new URLSearchParams(window.location.search);

    // Append the current query parameters to the iframe URL
    const appendQueryParams = (url) => {
        const iframeUrl = new URL(url);
        currentQueryParams.forEach((value, key) => {
            iframeUrl.searchParams.append(key, value);
        });
        return iframeUrl.toString();
    };

    const urlWithParams = appendQueryParams(cardData.url);

    return (
        <Card
            sx={{
                marginBottom: 0,
                borderRadius: 2, // Rounded corners for a modern look
                overflow: "hidden", // Ensures the image fits within the card
                boxShadow: "0 0px 8px rgba(0, 0, 0, 0)", // Subtle shadow for better elevation
            }}
        >
            <iframe
                src={urlWithParams}
                title="Web Card"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                }}
            />
        </Card>
    );
};

export default Card38WebCard;